import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    if (userProfileSession) {
      setUserProfile(userProfileSession);
      setToken(userProfileSession["accessToken"] || null);
    } else {
      setUserProfile(null);
      setToken(null);
    }
    setLoading(false);
  }, []);

  return { userProfile, token, loading };
};

export { useProfile };
